const statusEnum = [
  {
    id: 'ACTIVE',
    name: 'ACTIVE',
  },
  {
    id: 'DELETED',
    name: 'DELETED',
  },
];

export default statusEnum;
